import { CloudOff, RefreshCw } from "lucide-react";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { DiscardConfirm, disarmUnsavedGuards, hasUnsavedEdits } from "../admin/unsaved.tsx";
import { Button } from "../components/Button.tsx";
import { useOnline } from "./online.ts";
import { applyUpdate, useUpdateAvailable } from "./update-store.ts";

/** Small glass badge while the device has no connection. */
export function OfflineBadge() {
  const { t } = useTranslation();
  const online = useOnline();
  if (online) return null;
  return (
    <div className="offline-badge ds-glass ds-text-caption-1" role="status">
      <CloudOff aria-hidden="true" size={16} strokeWidth={1.75} />
      {t("offline.badge")}
    </div>
  );
}

/**
 * "New version available": the update is applied only when the person taps the button; with unsaved
 * admin edits open, they are asked first (the reload would drop them).
 */
export function UpdateToast() {
  const { t } = useTranslation();
  const available = useUpdateAvailable();
  const [confirm, setConfirm] = useState(false);
  if (!available) return null;
  return (
    <>
      <div className="pwa-toast ds-glass ds-text-subheadline" role="status">
        <RefreshCw aria-hidden="true" size={20} strokeWidth={1.75} className="shrink-0" />
        <span className="flex-1">{t("pwa.updateAvailable")}</span>
        <Button
          variant="tinted"
          onClick={() => (hasUnsavedEdits() ? setConfirm(true) : void applyUpdate())}
        >
          {t("pwa.reload")}
        </Button>
      </div>
      {confirm ? (
        <DiscardConfirm
          onDiscard={() => {
            setConfirm(false);
            disarmUnsavedGuards(); // they just chose to discard: no second native prompt
            void applyUpdate();
          }}
          onKeep={() => setConfirm(false)}
        />
      ) : null}
    </>
  );
}
